import app from 'flarum/forum/app';

// Set once the backend reports the AI as off or out of budget (503/402);
// neither changes within a page session.
let disabledForSession = false;
export function aiAvailable() {
  return !disabledForSession && !!app.session.user && !!app.forum.attribute('glowingblueSearchChatAvailable');
}
export function disableAiForSession() {
  disabledForSession = true;
}
flarum.reg.add('glowingblue-search', 'forum/ai/availability', { aiAvailable: aiAvailable,disableAiForSession: disableAiForSession, });